import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import HeroSection from '../../components/HeroSection/HeroSection';
import Footer from '../../components/Footer/Footer'; // Import Footer component
// import Sponsors from '../../components/Sponsors/Sponsors';
import PromotionalBanner from '../../components/PromotionalBanner/PromotionalBanner';


const IntroPage = () => {
  return (
    <div>
      <Navbar />
      <PromotionalBanner />
      <HeroSection />
      {/* <Sponsors /> */}
      <Footer />
    </div>
  );
};

export default IntroPage;
